import axios from 'axios';
import Vue from 'vue';

export default {
  state: {
    documentReviewAgentRunsByDocId: {},
    documentReviewAgentRunsByCustomerUUID: {},
    customerReviewAgentRunsByCustomerUUID: {},
    businessComplianceAgentRunsByCustomerUUID: {},
  },
  actions: {
    async fetchAndCacheDocumentReviewAgentRunsForDocId(
      context,
      { documentId, customerUUID },
    ) {
      const res = await axios.get(
        `/api/v2/agents/runs?document_id=${documentId}&customer_uuid=${customerUUID}`,
      );
      const runs = res.data.data ?? [];
      // Vue.set is required so that the reactivity system will update when
      // an object key changes
      Vue.set(context.state.documentReviewAgentRunsByDocId, documentId, runs);
    },
    async fetchAndCacheDocumentReviewAgentRunsForCustomerUUID(
      context,
      customerUUID,
    ) {
      const res = await axios.get(
        `/api/v2/agents/runs?customer_uuid=${customerUUID}`,
      );
      const runs = res.data.data ?? [];
      // Vue.set is required so that the reactivity system will update when
      // an object key changes
      Vue.set(
        context.state.documentReviewAgentRunsByCustomerUUID,
        customerUUID,
        runs,
      );
    },
    async fetchAndCacheCustomerReviewAgentRunsForCustomerUUID(
      context,
      customerUUID,
    ) {
      const res = await axios.get(
        `/api/v2/agents/customer-review/runs?customer_uuid=${customerUUID}`,
      );
      const runs = res.data.data ?? [];
      // Vue.set is required so that the reactivity system will update when
      // an object key changes
      Vue.set(
        context.state.customerReviewAgentRunsByCustomerUUID,
        customerUUID,
        runs,
      );
    },
    async fetchAndCacheBusinessComplianceAgentRunsForCustomerUUID(
      context,
      customerUUID,
    ) {
      const res = await axios.get(
        `/api/v2/agents/business-compliance/runs?customer_uuid=${customerUUID}`,
      );
      const runs = res.data.data ?? [];
      // Vue.set is required so that the reactivity system will update when
      // an object key changes
      Vue.set(
        context.state.businessComplianceAgentRunsByCustomerUUID,
        customerUUID,
        runs,
      );
    },
  },
  getters: {
    getCachedDocumentReviewAgentRunsForDocId: (state) => (documentId) => {
      if (!documentId) {
        return undefined;
      }
      return state.documentReviewAgentRunsByDocId[documentId];
    },
    getCachedDocumentReviewAgentRunsForCustomerUUID:
      (state) => (customerUUID) => {
        if (!customerUUID) {
          return undefined;
        }

        return state.documentReviewAgentRunsByCustomerUUID[customerUUID];
      },
    getCachedCustomerReviewAgentRunsForCustomerUUID:
      (state) => (customerUUID) => {
        if (!customerUUID) {
          return undefined;
        }

        return state.customerReviewAgentRunsByCustomerUUID[customerUUID];
      },
    getCachedBusinessComplianceAgentRunsForCustomerUUID:
      (state) => (customerUUID) => {
        if (!customerUUID) {
          return undefined;
        }

        return state.businessComplianceAgentRunsByCustomerUUID[customerUUID];
      },
  },
};
